import { addDoc, collection, getDocs, query, updateDoc, where, doc, serverTimestamp, getDoc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export const sendMessage = async ({ msg, doctorId, patientId, sender }) => {
  if (!msg) return;

  const messagePayload = {
    msg,
    sender,
    receiver: sender === doctorId ? patientId : doctorId,
    created_on: serverTimestamp(),
  };

  // Save message
  await addDoc(collection(db, "messages"), messagePayload);

  // Update or create chatsSummary
  const chatSummaryId = `${doctorId}_${patientId}`;
  const summaryDocRef = doc(db, "chatsSummary", chatSummaryId);

  const summaryPayload = {
    doctorId,
    patientId,
    lastMessage: msg,
    created_on: serverTimestamp(),
    sender,
    readByDoctor: sender === doctorId,
    readByPatient: sender === patientId,
  };

  // Check if document exists
  const existingDoc = await getDoc(summaryDocRef);

  if (existingDoc.exists()) {
    await updateDoc(summaryDocRef, summaryPayload);
  } else {
    await setDoc(summaryDocRef, summaryPayload);
  }
};
